export default __webpack_public_path__ + "static/2-2-1-0-5b7e11dd420bc228b0191e07fcea29a3.jpg";